import { render } from "./WarningData.vue?vue&type=template&id=632ba32c"
import script from "./WarningData.vue?vue&type=script&lang=js"
export * from "./WarningData.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__